import React from "react";
import TranslatableText from "../Shared/TranslatableText";

export default function ReviewDetailModal({
  activeReviewDetail = null,
  setActiveReviewDetail = () => {},
  PublicProfileNameButton,
  renderStars = () => null,
  formatReviewDateTime = () => "",
  openPropertyFromNotification = () => {},
  openPublicProfile = () => {},
  styles = {},
}) {
  if (!activeReviewDetail) return null;

  return (
    <div style={styles.replyModalOverlay} onClick={() => setActiveReviewDetail(null)}>
      <div style={styles.replyModalCard} onClick={(event) => event.stopPropagation()}>
        <div style={styles.replyModalHeader}>
          <div>
            <div style={styles.replyModalEyebrow}>Review detail</div>
            <div style={styles.replyModalTitle}>
              {activeReviewDetail?.propertyTitle ||
                activeReviewDetail?.targetDisplayName ||
                "Rental trust review"}
            </div>
          </div>
          <button style={styles.replyModalCloseButton} onClick={() => setActiveReviewDetail(null)}>
            Close
          </button>
        </div>

        <div style={styles.replyModalReviewCard}>
          <div style={styles.reviewHeaderRow}>
            <div>
              <PublicProfileNameButton
                userData={{
                  uid: activeReviewDetail?.reviewerUserId,
                  displayName: activeReviewDetail?.reviewerDisplayName || "Reviewer",
                  photoURL: activeReviewDetail?.reviewerPhotoURL,
                  verified: activeReviewDetail?.reviewerVerified,
                }}
                style={styles.strongHeading}
              >
                {activeReviewDetail?.reviewerDisplayName || "Reviewer"}
              </PublicProfileNameButton>
              <div style={styles.smallText}>
                {activeReviewDetail?.reviewerVerified ? "Verified weighted review" : "Community review"}
              </div>
            </div>
            <div style={styles.starText}>{renderStars(Number(activeReviewDetail?.rating || 0))}</div>
          </div>
          {activeReviewDetail?.isUpdatedReview ? (
            <p style={styles.communityReviewTag}>Updated Review</p>
          ) : null}
          {activeReviewDetail?.text ? (
            <TranslatableText text={activeReviewDetail.text} label="Review" bodyStyle={styles.bodyCopy} compact />
          ) : (
            <div style={styles.smallText}>Star-only community rating.</div>
          )}
          <div style={styles.reviewTimestamp}>
            {activeReviewDetail?.createdAt?.seconds
              ? formatReviewDateTime(activeReviewDetail.createdAt)
              : "Recent review"}
          </div>
        </div>

        <div style={styles.publicProfileActionRow}>
          {activeReviewDetail?.propertyId ? (
            <button
              style={{ ...styles.secondaryButton, marginTop: 0, flex: "1 1 160px" }}
              onClick={() => {
                openPropertyFromNotification(activeReviewDetail.propertyId);
                setActiveReviewDetail(null);
              }}
            >
              Open Property
            </button>
          ) : null}
          {activeReviewDetail?.targetUserId ? (
            <button
              style={{ ...styles.secondaryButton, marginTop: 0, flex: "1 1 160px" }}
              onClick={() => {
                openPublicProfile({
                  uid: activeReviewDetail.targetUserId,
                  displayName: activeReviewDetail.targetDisplayName || "User",
                });
                setActiveReviewDetail(null);
              }}
            >
              Open Profile
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
